<template> 
  <TsSection
    v-if="
      categorySitemapResponse &&
      categorySitemapResponse.data &&
      categorySitemapResponse.data.length
    "
    append-class="mb-0"
  >
    <TsTitle size="md" data-testid="sitemap-heading">Sitemap</TsTitle>
    <TsCardSitemapList
      :list="categorySitemapResponse.data"
      data-testid="category-sitemap-list"
    />
  </TsSection>
  <TsSection v-else-if="status === 'pending'" class="py-6 md:py-10">
    <TsSitemapListLoader v-for="n in 2" />
  </TsSection>
  
<TsSection>
  <TsDivider style="margin-top: -14px;"></TsDivider>
  <div v-if="footerContentLinks && footerContentLinks.length > 0" class="mb-8">
    <ul class="space-y-4 mb-6">
     <li
  v-for="(tab, index) in footerContentLinks"
  :key="tab.data.heading.name"
  :class="tab.data.heading.name === 'Blogs, nieuws en advies' ? 'pb-8' : ''"
>
        <div>
  <NuxtLinkWithLocale
    v-if="tab?.data?.heading?.url"
    :to="tab.data.heading.url"
    class="text-black font-bold text-base block"
  >
    {{ tab?.data?.heading?.name || '' }}
  </NuxtLinkWithLocale>

  <span
    v-else
    class="text-black font-bold text-base block"
  >
    {{ tab?.data?.heading?.name || '' }}
  </span>
</div>

        <div
          v-if="tab.data.links?.length > 0 && tab.data.heading.name !== 'Blogs, nieuws en advies'"
          class="pl-4 mt-2 flex flex-wrap gap-x-4 gap-y-2"
        >
          <NuxtLinkWithLocale
            v-for="(item, i) in tab.data.links"
            :key="item.name"
            :to="item?.url || ''"
            :target="item?.openInNewTab ? '_blank' : '_self'"
            :data-testid="`sitemap-${(item.url || '').replace(/\//g, '-')}-list`"
            class="text-sm text-black"
          >
            {{ item.name }}
          </NuxtLinkWithLocale>
        </div>
        
        <TsDivider v-if="index < footerContentLinks.length - 1" class="my-4" />
      </li>
    </ul>
  </div>
</TsSection>




</template>

<script lang="ts" setup>

const nuxtApp = useNuxtApp();
const runtimeConfig = useRuntimeConfig();

const TsCardSitemapList = defineAsyncComponent(
  () => import("~/components/organisms/TsCardSitemapList.vue")
);

const TsSitemapListLoader = defineAsyncComponent(
  () => import("~/components/atoms/TsSitemapListLoader.vue")
);

type Props = {
  dataTestid?: string;
  dataFetchKey?: string;
};

const props = withDefaults(defineProps<Props>(), {
  dataFetchKey: "footer-links",
});

import { EcomService } from "~/services/ecom.service";

// Category sitemap fetch
 const { data: categorySitemapResponse, status } = await useAsyncData(
   "categories-sitemap",
   () => EcomService.getCategorySitemap(nuxtApp, runtimeConfig),
   {
    lazy: true,
    dedupe: "cancel",
   }
 );


// Footer links fetch
const footerContentLinks = ref<any[]>([])

const { data: footerContentLinksRaw } = await useAsyncData(
  props.dataFetchKey,
  () =>
    fetchFooterLinks(
      runtimeConfig.public.builderApiKey,
      { locale: nuxtApp.$i18n.defaultLocale },
      nuxtApp
    ),
  {
    lazy: true,
    dedupe: "cancel",
    watch: [nuxtApp.$i18n.locale],
  }
)

watchEffect(() => {
  if (footerContentLinksRaw.value) {
    footerContentLinks.value = footerContentLinksRaw.value
  }
})

async function fetchFooterLinks(
  apiKey: any,
  opts: object,
  nuxtApp: any = null,
  redisCacheBurst = false
) {
  const { getFooterLinks } = await import(
    "~/services-optimized/builderService"
  );
  return await getFooterLinks(apiKey, opts, nuxtApp, redisCacheBurst);
}

// Error handling for sitemap fetch
const errorOccured =
  categorySitemapResponse.value &&
  "success" in categorySitemapResponse.value &&
  !categorySitemapResponse.value.success;

if (errorOccured) {
  throw createError({
    statusCode: 404,
    statusMessage: "Failed to fetch sitemap",
  });
}

definePageMeta({
  layout: "sitemap",
});
</script>
